import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { authHeader } from "../../services/auth-header";
import { BASE_URL } from "../../services/Api";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";

import PumpDomesticSOConversion from "./Conversions/PumpDomesticSOConversion";
import PumpInternationalSOConversion from "./Conversions/PumpInternationalConversion";
import AraiMfgDomesticSOConversion from "./Conversions/ManufacturingDomesticSOConversion";
import ManufacturingInternationalSOConversion from "./Conversions/ManufacturingInternationalSOConversion";

const SQtoSOConversion = () => {
  const { id, pointindex } = useParams();
  const [productType, setProductType] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [enquiryData, setEnquiryData] = useState(null);

  async function getData() {
    try {
      const response = await axios.get(`${BASE_URL}quotation/findById/${id}`, {
        headers: authHeader(),
      });

      setEnquiryData(response.data);
      setProductType(response.data.quotationtype);
      setProductCategory(response.data.quotationcategory);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (enquiryData) console.log(enquiryData);
  }, [enquiryData]);

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <PumpDomesticSOConversion enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <PumpInternationalSOConversion enquiryData={enquiryData} />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <AraiMfgDomesticSOConversion enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <ManufacturingInternationalSOConversion enquiryData={enquiryData} />;
      }
    }
    return null;
  }

  return (
    <div className="container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>Sales Quotation to Sales Order Conversion</h6>
          <Link to={`/salesOrderIndexTable/1`}>
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Sales Order Type:</Form.Label>
                <Form.Select
                  onChange={(e) => setProductType(e.target.value)}
                  value={productType}
                  disabled={!!productType}
                >
                  <option value="">--Please choose an option--</option>
                  {/* Removed Tubing option */}
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Sales Order Category:</Form.Label>
                <Form.Select
                  disabled={!productType || !!productCategory}
                  value={productCategory}
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SQtoSOConversion;
